/* eslint-disable import/prefer-default-export */
export const EXP_32_TRIALS = 'projects-exp-32-help-modal-revision';
export const EXP_32_CUSTOMERS = 'projects-exp-32-help-modal-revision-customers';
